'use strict'

function directPageRecordSpreadSheet (pages, page) {

  if (!page || !page.parentUniqueTitle) return null

  const parent = (pages || []).find(item => item && item.uniqueTitle === page.parentUniqueTitle)

  if (!parent) return null

  return spreadsheetLinkedToPage(parent.components, page.uniqueTitle)
}

function menuCarriedPageUniqueTitles (page) {

  const targets = []

  function addItems (items) {

    for (const item of items || []) {

      if (item && item.type === 'link' && item.inheritAccessKey === true && item.pageUniqueTitle) {

        targets.push(item.pageUniqueTitle)
      }

      addItems(item && item.children)
    }
  }

  walkComponents(page && page.components, (component) => {

    if (component.type === 'menu') addItems(component.menuItems)
  })

  return targets
}

function carriedPageRecordSpreadSheet (pages, page, seen) {

  const sources = (pages || []).filter(source => {

    return source
      && source.uniqueTitle
      && source.uniqueTitle !== page.uniqueTitle
      && menuCarriedPageUniqueTitles(source).includes(page.uniqueTitle)
  })

  sources.sort((left, right) => {

    const rank = (item) => item.uniqueTitle === page.parentUniqueTitle ? 0 : 1

    return rank(left) - rank(right)
  })

  for (const source of sources) {

    const carried = findPageRecordSpreadSheet(pages, source, seen)

    if (carried) return carried
  }

  return null
}

function findPageRecordSpreadSheet (pages, page, seen) {

  if (!page || !page.uniqueTitle) return null

  const direct = directPageRecordSpreadSheet(pages, page)

  if (direct) return direct

  const visiting = seen || new Set()

  if (visiting.has(page.uniqueTitle)) return null

  visiting.add(page.uniqueTitle)

  return carriedPageRecordSpreadSheet(pages, page, visiting)
}

function spreadsheetLinkedToPage (components, childPageUniqueTitle) {

  let match = null

  function walk (nodes, ancestorSpreadsheet) {

    for (const component of nodes || []) {

      if (match) return

      const spreadsheet = component.spreadSheet || ancestorSpreadsheet || null

      if (component.type === 'link' && component.childPageUniqueTitle === childPageUniqueTitle && spreadsheet) {

        match = spreadsheet
        return
      }

      walk(component.components, spreadsheet)
    }
  }

  walk(components, null)

  return match
}

function relatedSpreadSheetUniqueTitles (spreadsheets, pageRecordSpreadSheetUniqueTitle) {

  const related = new Set()

  if (!pageRecordSpreadSheetUniqueTitle) return related

  const pageRecord = (spreadsheets || []).find(sheet => sheet && sheet.uniqueTitle === pageRecordSpreadSheetUniqueTitle)

  for (const sheet of spreadsheets || []) {

    if (!sheet || sheet.uniqueTitle === pageRecordSpreadSheetUniqueTitle || !sheet.columns) continue

    for (const column of sheet.columns) {

      if (column.type === 'relationship' && column.relatedSpreadSheet === pageRecordSpreadSheetUniqueTitle) {

        related.add(sheet.uniqueTitle)
      }
    }
  }

  if (pageRecord && pageRecord.columns) {

    for (const column of pageRecord.columns) {

      if (column.type === 'relationship' && column.relatedSpreadSheet) {

        related.add(column.relatedSpreadSheet)
      }
    }
  }

  return related
}

function pageRecordRelationship (spreadsheets, viewSpreadSheetUniqueTitle, pageRecordSpreadSheetUniqueTitle) {

  if (!viewSpreadSheetUniqueTitle || !pageRecordSpreadSheetUniqueTitle) return null

  if (viewSpreadSheetUniqueTitle === pageRecordSpreadSheetUniqueTitle) return null

  const list = spreadsheets || []
  const viewSheet = list.find(sheet => sheet && sheet.uniqueTitle === viewSpreadSheetUniqueTitle)
  const pageRecord = list.find(sheet => sheet && sheet.uniqueTitle === pageRecordSpreadSheetUniqueTitle)
  const pageRecordTitle = (pageRecord && (pageRecord.title || pageRecord.uniqueTitle)) || pageRecordSpreadSheetUniqueTitle

  if (viewSheet && viewSheet.columns) {

    const column = viewSheet.columns.find(item => item.type === 'relationship' && item.relatedSpreadSheet === pageRecordSpreadSheetUniqueTitle)

    if (column) {

      return {
        columnTitle: column.title || column.uniqueTitle,
        pageRecordTitle
      }
    }
  }

  if (pageRecord && pageRecord.columns) {

    const column = pageRecord.columns.find(item => item.type === 'relationship' && item.relatedSpreadSheet === viewSpreadSheetUniqueTitle)

    if (column) {

      return {
        columnTitle: column.title || column.uniqueTitle,
        pageRecordTitle
      }
    }
  }

  return null
}

function pageRecordFilterForView (spreadsheets, pages, page, viewSpreadSheetUniqueTitle) {

  const pageRecordSpreadSheet = findPageRecordSpreadSheet(pages, page)

  if (!pageRecordSpreadSheet) {

    return {
      ok: false,
      message: 'This page is not opened from a record. Link to it from that record and set parentUniqueTitle before filtering the view.'
    }
  }

  const relationship = pageRecordRelationship(spreadsheets, viewSpreadSheetUniqueTitle, pageRecordSpreadSheet)

  if (!relationship) {

    const pageRecord = (spreadsheets || []).find((sheet) => sheet && sheet.uniqueTitle === pageRecordSpreadSheet)
    const pageRecordTitle = (pageRecord && (pageRecord.title || pageRecord.uniqueTitle)) || pageRecordSpreadSheet

    return {
      ok: false,
      message: `No relationship connects ${viewSpreadSheetUniqueTitle} to ${pageRecordTitle}. The page-record filter was not saved.`
    }
  }

  return {
    ok: true,
    pageRecordSpreadSheet,
    columnTitle: relationship.columnTitle,
    pageRecordTitle: relationship.pageRecordTitle,
    message: `Only records related to the page's ${relationship.pageRecordTitle} record through ${relationship.columnTitle} are shown.`
  }
}

function syncSavedPage (pages, saved) {

  if (!saved || !saved.uniqueTitle) return null

  const existing = (pages || []).find(item => item && item.uniqueTitle === saved.uniqueTitle)

  if (!existing || existing === saved) return existing || null

  const children = existing.children

  Object.keys(existing).forEach((key) => {

    if (key !== 'children') delete existing[key]
  })

  Object.assign(existing, saved)

  if (children) existing.children = children
  else delete existing.children

  return existing
}

function applyPageRecordFilter (component, filterByPageRecord) {

  if (!component || filterByPageRecord === undefined) return component

  if (filterByPageRecord) component.filterByPageRecord = true
  else delete component.filterByPageRecord

  return component
}

const RECORD_VIEW_TYPES = new Set([
  'table',
  'pivot',
  'cards',
  'card',
  'form',
  'chart',
  'calendar',
  'maps',
  'map',
  'carousel',
  'login',
  'registration'
])

function walkComponents (components, visit) {

  for (const component of components || []) {

    if (!component) continue

    visit(component)
    walkComponents(component.components, visit)
  }
}

function relationshipSpreadSheets (page) {

  const sheets = []

  walkComponents(page && page.components, (component) => {

    if (!component.filterByPageRecord || !component.spreadSheet) return

    if (!sheets.includes(component.spreadSheet)) sheets.push(component.spreadSheet)
  })

  return sheets
}

function recordSpreadSheetsOnPage (page, pages) {

  const sheets = new Set()
  const pageRecord = findPageRecordSpreadSheet(pages, page)

  if (pageRecord) sheets.add(pageRecord)

  walkComponents(page && page.components, (component) => {

    if (component.spreadSheet && RECORD_VIEW_TYPES.has(component.type)) {

      sheets.add(component.spreadSheet)
    }
  })

  return [...sheets]
}

function pageIsUnder (page, ancestorUniqueTitle, pages) {

  const byTitle = new Map()

  for (const item of pages || []) {

    if (item && item.uniqueTitle) byTitle.set(item.uniqueTitle, item)
  }

  const seen = new Set()
  let current = page

  while (current && current.parentUniqueTitle) {

    if (seen.has(current.uniqueTitle)) return false

    seen.add(current.uniqueTitle)

    if (current.parentUniqueTitle === ancestorUniqueTitle) return true

    current = byTitle.get(current.parentUniqueTitle)
  }

  return false
}

function canPlacePageUnder (dragged, targetParent, pages, spreadsheets) {

  if (!dragged || !dragged.uniqueTitle) return true

  if (targetParent && targetParent.uniqueTitle === dragged.uniqueTitle) return false

  if (targetParent && pageIsUnder(targetParent, dragged.uniqueTitle, pages)) return false

  const currentParent = dragged.parentUniqueTitle || null
  const nextParent = (targetParent && targetParent.uniqueTitle) || null

  if (currentParent === nextParent) return true

  const needed = relationshipSpreadSheets(dragged)

  if (!needed.length) return true

  if (!nextParent) return false

  const offered = recordSpreadSheetsOnPage(targetParent, pages)

  return offered.some((sheet) => {

    return needed.every((viewSheet) => pageRecordRelationship(spreadsheets, viewSheet, sheet))
  })
}

function pageDragFilter (evt, target, sortable) {

  const origin = evt && evt.target

  if (!origin || typeof origin.closest !== 'function' || !sortable) return false

  const nest = origin.closest('.page-nest-drop')

  if (!nest || nest === sortable.el) return false

  return true
}

module.exports = {
  findPageRecordSpreadSheet,
  spreadsheetLinkedToPage,
  relatedSpreadSheetUniqueTitles,
  pageRecordRelationship,
  pageRecordFilterForView,
  syncSavedPage,
  applyPageRecordFilter,
  relationshipSpreadSheets,
  recordSpreadSheetsOnPage,
  canPlacePageUnder,
  pageDragFilter
}
